export const ROW_DEFINITIONS = [
  {
    key: 'ventas_exentas',
    title: 'VENTAS EXENTAS',
    codes: ['34'],
    section: 'ventas',
    pagoField: null,
  },
  {
    key: 'nd_exentas',
    title: 'N/D EXENTAS',
    codes: ['56'],
    section: 'ventas',
    pagoField: null,
  },
  {
    key: 'nc_exentas',
    title: 'N/C EXENTAS',
    codes: ['61'],
    section: 'ventas',
    pagoField: null,
  },
  {
    key: 'ventas_exportacion',
    title: 'VENTAS EXPORTACIÓN',
    codes: ['110'],
    section: 'ventas',
    montoField: 'neto',
    pagoField: null,
  },
  {
    key: 'nc_exportacion',
    title: 'NC EXPORTACIÓN',
    codes: ['112'],
    section: 'ventas',
    montoField: 'neto',
    pagoField: null,
  },
  {
    key: 'ventas_factura',
    title: 'VENTAS AFECTAS CON FACTURA',
    codes: ['33'],
    section: 'ventas',
    summaryGroup: 'total_iva_debito',
    montoField: 'neto',
  },
  {
    key: 'ventas_boletas',
    title: 'VENTAS AFECTAS CON BOLETAS',
    codes: ['39'],
    section: 'ventas',
    summaryGroup: 'total_iva_debito',
    montoField: 'neto',
  },
  {
    key: 'ventas_pago_electronico',
    title: 'VENTAS AFECTAS CON PAGO ELECTRONICO',
    codes: ['48'],
    section: 'ventas',
    summaryGroup: 'total_iva_debito',
    montoField: 'neto',
  },
  {
    key: 'nd_afectas',
    title: 'N/D AFECTAS',
    codes: ['56'],
    section: 'ventas',
    summaryGroup: 'total_iva_debito',
    montoField: 'neto',
  },
  {
    key: 'nc_afectas',
    title: 'N/C AFECTAS',
    codes: ['61'],
    section: 'ventas',
    summaryGroup: 'total_iva_debito',
    summaryFactor: -1,
    montoField: 'neto',
  },
  {
    key: 'liquidacion_factura',
    title: 'LIQUIDACION FACTURA AFECTAS',
    codes: ['43'],
    section: 'ventas',
    summaryGroup: 'total_iva_debito',
    montoField: 'neto',
  },
  {
    key: 'compras_exentas',
    title: 'COMPRAS EXENTAS',
    codes: ['33', '34'],
    section: 'compras',
    codeLabel: '33-34',
    pagoField: null,
  },
  {
    key: 'compras_nd_exentas',
    title: 'N/D EXENTAS',
    codes: ['56'],
    section: 'compras',
    pagoField: null,
  },
  {
    key: 'compras_nc_exentas',
    title: 'N/C EXENTAS',
    codes: ['61'],
    section: 'compras',
    pagoField: null,
  },
  {
    key: 'compras_afectas',
    title: 'COMPRAS AFECTAS',
    codes: ['33'],
    section: 'compras',
    summaryGroup: 'total_iva_credito',
    montoField: 'neto',
  },
  {
    key: 'compras_liquidacion',
    title: 'COMPRAS AFECTAS LIQUIDACIÓN FACTURA',
    codes: ['43'],
    section: 'compras',
    summaryGroup: 'total_iva_credito',
    montoField: 'neto',
  },
  {
    key: 'compras_facturas',
    title: 'COMPRAS AFECTAS FACTURAS DE COMPRA',
    codes: ['45', '46'],
    section: 'compras',
    codeLabel: '45-46',
    summaryGroup: 'total_iva_credito',
    montoField: 'neto',
  },
  {
    key: 'compras_nd_afectas',
    title: 'N/D AFECTAS',
    codes: ['56'],
    section: 'compras',
    summaryGroup: 'total_iva_credito',
    montoField: 'neto',
  },
  {
    key: 'compras_nc_afectas',
    title: 'N/C AFECTAS',
    codes: ['61'],
    section: 'compras',
    summaryGroup: 'total_iva_credito',
    summaryFactor: -1,
    montoField: 'neto',
  },
  {
    key: 'importaciones',
    title: 'IMPORTACIONES',
    codes: ['914'],
    section: 'compras',
    summaryGroup: 'total_iva_credito',
    montoField: 'neto',
  },
  {
    key: 'retencion_145',
    title: 'RETENCION BOLETAS 14.5%',
    summaryGroup: 'retencion_boleta',
    quantityLabel: '14,50%',
    resolver: ({ dataMap }) => {
      const honorarioRow = dataMap.get('HONORARIO')
      const total = Number(
        honorarioRow?.total?.retencion ??
          honorarioRow?.total?.total ??
          honorarioRow?.total ??
          0
      )
      return {
        key: 'retencion_145',
        concepto: 'RETENCION BOLETAS 14.5%',
        codigo: '-',
        cantidadDocumentos: '14,50%',
        monto: total,
        montoAPagar: total,
        section: 'retenciones',
      }
    },
  },
  {
    key: 'retencion_3',
    title: 'RETENCION BOLETAS 3%',
    summaryGroup: 'retencion_boleta',
    quantityLabel: '3%',
    montoLabel: '-',
    resolver: () => ({
      key: 'retencion_3',
      concepto: 'RETENCION BOLETAS 3%',
      codigo: '-',
      cantidadDocumentos: '3%',
      monto: '-',
      montoAPagar: 0,
      section: 'retenciones',
    }),
  },
  {
    key: 'impuesto_unico',
    title: 'IMPUESTO UNICO RETENIDO',
    summaryGroup: 'impuesto_unico_trabajadores',
    quantityLabel: '-',
    resolver: ({ dataMap }) => {
      const impuestoRow = dataMap.get('IMPUESTO_144_ACTUAL')
      const amount = Number(impuestoRow?.total?.total ?? impuestoRow?.total ?? 0)
      return {
        key: 'impuesto_unico',
        concepto: 'IMPUESTO UNICO RETENIDO',
        codigo: '-',
        cantidadDocumentos: '-',
        monto: amount,
        montoAPagar: amount,
        section: 'impuestos',
      }
    },
  },
  {
    key: 'impuesto_unico_3',
    title: 'IMPUESTO UNICO RETENIDO 3%',
    summaryGroup: 'retencion_prestamo',
    quantityLabel: '-',
    montoLabel: '-',
    resolver: () => ({
      key: 'impuesto_unico_3',
      concepto: 'IMPUESTO UNICO RETENIDO 3%',
      codigo: '-',
      cantidadDocumentos: '-',
      monto: '-',
      montoAPagar: 0,
      section: 'impuestos',
    }),
  },
  {
    key: 'ppm',
    title: 'PPM',
    summaryGroup: 'ppm',
    resolver: () => ({
      key: 'ppm',
      concepto: 'PPM',
      codigo: '-',
      cantidadDocumentos: '-',
      monto: '-',
      montoAPagar: 0,
      section: 'impuestos',
    }),
  },
  {
    key: 'remanente_anterior',
    title: 'REMANENTE MES ANTERIOR',
    codes: ['REMANENTE'],
    section: 'compras',
    montoField: 'iva',
    pagoField: 'iva',
    codeLabel: '-',
    quantityLabel: '-',
    montoLabel: '-',
    summaryGroup: 'remanente_iva_mes_anterior',
  },
  {
    key: 'iva_servicios',
    title: 'IVA SERVICIOS DIGITALES',
    summaryGroup: 'iva_facturas_internacionales',
    quantityLabel: '-',
    montoLabel: '-',
    resolver: () => ({
      key: 'iva_servicios',
      concepto: 'IVA SERVICIOS DIGITALES',
      codigo: '-',
      cantidadDocumentos: '-',
      monto: '-',
      montoAPagar: 0,
      section: 'otros',
    }),
  },
  {
    key: 'iva_servicios_nc',
    title: 'IVA SERVICIOS DIGITALES N/C',
    quantityLabel: '-',
    montoLabel: '-',
    resolver: () => ({
      key: 'iva_servicios_nc',
      concepto: 'IVA SERVICIOS DIGITALES N/C',
      codigo: '-',
      cantidadDocumentos: '-',
      monto: '-',
      montoAPagar: 0,
      section: 'otros',
    }),
  },
  {
    key: 'devolucion_export',
    title: 'DEVOLUCIÓN IVA EXPORTACIONES',
    summaryGroup: 'devolucion_exportaciones',
    quantityLabel: '-',
    montoLabel: '-',
    resolver: () => ({
      key: 'devolucion_export',
      concepto: 'DEVOLUCIÓN IVA EXPORTACIONES',
      codigo: '-',
      cantidadDocumentos: '-',
      monto: '-',
      montoAPagar: 0,
      section: 'otros',
    }),
  },
]
